<!-- eslint-disable vue/valid-v-for -->
<template>
  <div>
    <div v-if="loginDefine.length > 1">
      <a-tabs default-active-key="0">
        <a-tab-pane v-for="(item, index) in loginDefine" :key="String(index)" :tab="item.name" force-rende>
          <component :is="item.component" @getLoginAccount="getLoginAccount" />
        </a-tab-pane>
      </a-tabs>
    </div>
    <div v-else>
      <component :is="loginDefine[0].component" @getLoginAccount="getLoginAccount" />
    </div>
    <div v-if="logoUi.appId=='10016'">
      <Privacy />
    </div>
  </div>
</template>

<script>

import { message } from 'ant-design-vue';

import api from '@/api';
import { post } from '@/utils/http';

// import { pointTools } from '@/utils/point';
import Baseunified from '@/utils/micro/baseunified';
import { getLogo } from '@/utils/intConfiguration';
import { getUiFitment } from '@/utils/accessResources';
import AccountLogin from './accountLogin.vue';
import VerificationLogin from './verificationLogin.vue';
// eslint-disable-next-line import/no-unresolved
import UserNameLogin from './useNameLogin.vue';

import {
  setAccount,
  setUserSys,
} from '../../login-handler';

import Privacy from './privacy.vue';

const baseModel = new Baseunified();
const { envList } = require('../../../../../config/dev.proxy');

export default {
  name: 'ZnLogin',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    AccountLogin,
    // eslint-disable-next-line vue/no-unused-components
    VerificationLogin,
    UserNameLogin,
    Privacy,
  },
  data() {
    return {
      logoUi: getLogo(),
      loginDefine: baseModel.getLoginDefine(),
    };
  },
  created() {
    // pointTools.traceClick({
    //   event_type: 'page_view',
    //   content: {
    //     event_id: 'page_login',
    //     event_name: '登录页',
    //   },
    // });
  },
  mounted() {
    // console.error(this.logoUi);
  },
  methods: {
    // 获取用户信息
    getLoginAccount(loginRes) {
      post(api.loginAccount, {}).catch(() => {
        message.error('用户信息查询失败');
      })
        .then((res) => {
          // 之后缓存菜单需要参数
          setAccount(res, loginRes);
          getUiFitment().finally(() => {
            if (res.id) {
              this.$store.commit('emptyTab');
              if (getLogo().appId == '100001') {
                this.$router.push('/live/home');
              } else {
                this.$router.push('/');
              }
            }
          });
        });
    },
  },
};
</script>
